<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="fetchClientOrders">
        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.fullName }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.phoneNumber }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ item.productName }}</template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.quantity }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">{{ formatPrice(item.totalPrice) }}</template>

        <template v-slot:edit="{ item, index }">
            <DeliveryClientOrdersActionMenu :Id="index" v-bind:idOrder="item.deliveryItemId" :ShowDialogStatus="true"
                :getClientOrdersByOrderId="fetchClientOrders" :deliveryPersonId="item.deliveryPersonId"
                :deliveryPersonName="item.deliveryPersonName" />
        </template>
    </gridComponent>
</template>

<script>
import { formatPrice, getClientOrdersByOrderId } from "@/api/index";
import GridComponent from '@/genericComponent/gridComponent.vue';
import DeliveryClientOrdersActionMenu from './DeliveryClientOrdersActionMenu.vue';

export default {
    components: { GridComponent, DeliveryClientOrdersActionMenu },
    props: {
        deliveryOrderId: {
            type: String,
            required: true,
        },
        deliveryItemId: {
            type: String,
            required: true,
        },
    },

    mounted() {
        this.fetchClientOrders();

        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
        });
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            filters: {
                SearchTitle: null,
                SearchQuantity: null,
                SearchTax: null,
                SearchPrice: null,
            },
            search: null,
            filterMenuitems: [1, 3, 4],
            brandName: null,
            FieldCategoryId: [],
            FieldCreatedDateFrom: null,
            FieldCreatedDateTo: null,
            FieldSupplierId: null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            MySupplier: null,
            item: null,
            suppliers: [],
            categories: [],
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        fetchClientOrders(page = this.page) {
            const params = {
                PageNumber: page,
                PageSize: this.PageSize,
                SortBy: this.SortedBy,
                SortDescending: this.SortingType == "DESC" ? true : false,
                SearchTitle: this.filters.SearchTitle,
                SearchTerm: this.filters.SearchTerm,
            };
            getClientOrdersByOrderId(this.deliveryOrderId, params)
                .then((response) => {
                    this.items = response.data.items;
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                    this.itemsData.hasNextPage = response.data.hasNextPage;
                    this.loader = false;
                })
                .catch((error) => {
                    console.error("Error fetching client orders:", error);
                });
        },
        getStatusLabel(isActif) {
            return isActif ? this.$t('common.active') : this.$t('common.inactive');
        },
        getStatusColor(isActif) {
            return isActif ? '#3BBAFF' : '#F25C5C';
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(filteredParams) {
            this.brandName = filteredParams.BrandName;
            this.FieldCategoryId = filteredParams.IdCategories;
            this.FieldSupplierId = filteredParams.supplierId;
            this.FieldCreatedDateFrom = filteredParams.CreatedFrom;
            this.FieldCreatedDateTo = filteredParams.CreatedTo;
            this.BrandsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
        headers() {
            const headers = [
                this.$t('Delivery.ClientOrders.ClientName'),
                this.$t('Delivery.ClientOrders.Phone'),
                this.$t('Delivery.ClientOrders.productName'),
                this.$t('Delivery.ClientOrders.quantity'),
                this.$t('Delivery.ClientOrders.totalPrice'),
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['20%', '15%', '15%', '20%', '15%'];
            return headers;
        },
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
